import { useLocation, useMatches } from "@remix-run/react";
import {
  init,
  browserTracingIntegration,
  replayIntegration,
  thirdPartyErrorFilterIntegration,
} from "@sentry/remix";
import type { Integration } from "@sentry/types";
import { useEffect } from "react";

import { currentEnv, isStaging, isProduction } from "@shared/utils/fullscriptEnv/fullscriptEnv";

const getIntegrations = (isReplayCompressionEnabled: boolean = true): Integration[] => {
  // Don't enable transactions and replays in staging, sandbox, development or test
  if (!isProduction()) return [];

  const integrations: Integration[] = [
    browserTracingIntegration({ useEffect, useLocation, useMatches }),
    replayIntegration({ useCompression: isReplayCompressionEnabled }),
    thirdPartyErrorFilterIntegration({
      filterKeys: ["hw-admin-js"],
      behaviour: "apply-tag-if-contains-third-party-frames",
    }),
  ];

  return integrations;
};

/**
 * Sentry initialization for the client
 */
const clientInitSentry = (enableSentryTunnel = false) => {
  init({
    dsn: window.ENV.SENTRY_DSN,
    tunnel: enableSentryTunnel ? "/api/sentry/reports" : undefined,
    environment: currentEnv(),
    integrations: getIntegrations(!enableSentryTunnel),
    enabled: window.ENV.FORCE_ENABLE_SENTRY || isProduction() || isStaging(),
    release: window.ENV.CI_COMMIT_SHA,
    tracesSampleRate: isProduction() ? 0.01 : 0.0,
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 0.0,
  });
};

export { clientInitSentry };
